module.exports = __webpack_public_path__ + "static/media/mh_logo.bf5f8ba0.svg";